import React from "react";

interface DateSeparatorProps {
  label: string;
}

const DateSeparator: React.FC<DateSeparatorProps> = ({ label }) => {
  return (
    <div className="flex items-center mb-6">
      <div className="flex-1 border-t border-gray-300"></div>
      <span className="px-4 text-sm text-gray-500 font-medium">{label}</span>
      <div className="flex-1 border-t border-gray-300"></div>
    </div>
  );
};

export default DateSeparator;
